import { GridColumnProps } from '@progress/kendo-react-grid'
import { TradingAccountLotsProfitStatisticDtoKey } from 'api/Trading-Accounts/Types/TradingAccountLotsProfitStatisticDto'
import { inputFilterCell } from 'components/Filter/FilterCell'

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

const InputFilterCell = inputFilterCell({
  options: {
    operator: 'like',
  },
})

export const transactionLotsProfitColumns: GridColumn[] = [
  {
    title: 'Trading Account',
    field: TradingAccountLotsProfitStatisticDtoKey.TRADING_ACCOUNT,
    filter: 'text',
    show: true,
  },
  {
    title: 'Wallet',
    field: TradingAccountLotsProfitStatisticDtoKey.WALLET,
    filterCell: InputFilterCell,
    filter: 'text',
    show: true,
  },
  {
    title: 'Instrument Type',
    field: TradingAccountLotsProfitStatisticDtoKey.INSTRUMENT_TYPE,
    filterCell: InputFilterCell,
    filter: 'text',
    show: true,
  },
  // {
  //     title: 'Profit',
  //     field: TradingAccountLotsProfitStatisticDtoKey.PROFIT,
  //     filterCell: InputFilterCell,
  //     filter: "numeric",
  //     show: true,
  // },
]
